import script from "./QTLiteSortIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteSortIcon.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteSortIcon.vue?vue&type=style&index=0&id=279cecd0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279cecd0"]])

export default __exports__